namespace RecordShield.Administration {
    export interface TenantDetailListRequest extends Serenity.ListRequest {
        StartDate?: string;
        EndDate?: string;
        PurchasedJournal?: string;
    }
}
